import './HeroSection.scss'
import {HeroImage} from './hero-img/HeroImage'
import {Link} from 'react-router-dom'
import {HashLink} from 'react-router-hash-link'
import config from '../../../../config'

export const HeroSection = ({children}) => {
    return (
        <section id={'hero'} className='hero-section'>
            <div className='hero-content-wrapper'>
                {children}
            </div>
            <HeroImage />
        </section>
    )
}


const Caption = ({ children }) => {
    return (
        <div className={'hero-caption'}>
            <span className={'hero-caption-text'}>{children}</span>
        </div>
    )
}
HeroSection.Caption = Caption


const Heading = ({ children }) => {
    return (
        <h1 className={'hero-heading'}>{children}</h1>
    )
}
HeroSection.Heading = Heading


const Description = ({ children }) => {
    return (
        <p className={'hero-description'}>{children}</p>
    )
}
HeroSection.Description = Description


const PrimaryCTA = ({ children }) => {
    return (
        <Link className={'primary-cta'} to={config.root + '/signup'}>{children}</Link>
    )
}
HeroSection.PrimaryCTA = PrimaryCTA


const SecondaryCTA = ({ children }) => {
    return (
        <HashLink className={'secondary-cta'} to={config.root + '#about'} >{children}</HashLink>
    )
}
HeroSection.SecondaryCTA = SecondaryCTA